import React from 'react'
import { useTranslation } from 'react-i18next'

import FieldLabelWrapper from '../../../../../../features/components/Form/FieldLabelWrapper'
import Field from '../../../../../../components/Form/Field'
import FileUploadField from '../../../../../../features/components/Form/FileUploadField'

import { FACEBOOK_BUSINESS_MANAGER_ID, ICON, ICON_NAME, NAME } from '../../../fields'
import useCommonStyles from '../../../../../../styles/common/listPage'
import useStyles from '../../../../EditProfile/styles'

const ProfileInfoRows = ({ formik }) => {
  const commonClasses = useCommonStyles()
  const classes = useStyles()

  const { t } = useTranslation()

  return (
    <>
      <div className={commonClasses.formRow}>
        <FieldLabelWrapper label={t('Name')} labelFor={NAME}>
          <Field formik={formik} id={NAME} name={NAME} placeholder={t('Name')} enableReinitialize />
        </FieldLabelWrapper>
        <FieldLabelWrapper label={t('Icon')} labelFor={ICON}>
          <FileUploadField
            formik={formik}
            fileUrlField={ICON}
            fileNameField={ICON_NAME}
            uploadButtonClassName={classes.uploadButton}
            uploadBtnLabelClassName={classes.uploadFileButtonLabel}
            filePreviewClassName={classes.filePreview}
          />
        </FieldLabelWrapper>
      </div>
      <div className={commonClasses.formRow}>
        <FieldLabelWrapper label={t('Facebook Business Manager ID')} labelFor={FACEBOOK_BUSINESS_MANAGER_ID}>
          <Field
            placeholder="Id"
            formik={formik}
            name={FACEBOOK_BUSINESS_MANAGER_ID}
            enableReinitialize
            autoComplete="off"
          />
        </FieldLabelWrapper>
        {/* don't delete this div, it's a workaround to keep layout aligned with not equal columns */}
        <div style={{ width: '100%' }}></div>
      </div>
    </>
  )
}

export default ProfileInfoRows
